(() => {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.close()
      );
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.setHeaderCartIconAccessibility();
    }

    connectedCallback() {
      setTimeout(() => {
        this.setDrawerInnerHeight();
      }, 275);
      // GB Test GS-861
      this.updateCartDrawerDiscountCode();
      // END GB Test GS-861
      document.addEventListener("Cart:Drawer:Changed", () => {
        this.setBannerVisibility();
        this.setShippingBarVisibility();
        // GB Test GS-861
        this.updateCartDrawerDiscountCode();
        // END GB Test GS-861

        setTimeout(() => {
          this.setDrawerInnerHeight();
        }, 275);
      });
    }

    // GB Test GS-861
    updateCartDrawerDiscountCode() {
      fetch(`${window.Shopify.routes.root}cart.js`)
        .then((res) => res.json())
        .then((data) => {
          // update the shipping discount code based on the cart updates - due to liquid not being able to check URL Params
          const urlParams = new URLSearchParams(window.location.search);
          const hasExperiment = urlParams.has(
            "10-experiment-test-increasing-free-shipping-threshold"
          );
          const isReachedNormalThreshold =
            data.items_subtotal_price >= 59 * 100;
          const isReachedExperimentThreshold =
            data.items_subtotal_price >= 75 * 100;
          if (document.querySelector("#discount-code-field")) {
            if (hasExperiment) {
              if (isReachedExperimentThreshold) {
                document.querySelector("#discount-code-field").value =
                  "ShippingFree75";
              } else {
                document.querySelector("#discount-code-field").value = "";
              }
            } else {
              if (isReachedNormalThreshold) {
                document.querySelector("#discount-code-field").value =
                  "ShippingFree59";
              } else {
                document.querySelector("#discount-code-field").value = "";
              }
            }
          }
        });
    }
    // End GB Test GS-861

    setBannerVisibility() {
      const drawerBanner = this.querySelector("[data-drawer-banner]");

      let fallbackHeight;

      const hasSubscriptionEl = this.querySelector("[data-has-subscription]");
      const hasSubscriptionData =
        hasSubscriptionEl.getAttribute("data-has-subscription") === "true"
          ? true
          : false;

      if (hasSubscriptionData) {
        drawerBanner.classList.add("drawer__banner--showing");
      } else {
        drawerBanner.classList.remove("drawer__banner--showing");
      }
    }

    setShippingBarVisibility() {
      const hasOtpEl = this.querySelector("[data-has-otp]");
      const hasOtpElData =
        hasOtpEl.getAttribute("data-has-otp") === "true" ? true : false;

      const drawerHeaderEl = this.querySelector("[data-drawer-header]");

      if (hasOtpElData) {
        drawerHeaderEl.classList.add("drawer__header--showing");
      } else {
        drawerHeaderEl.classList.remove("drawer__header--showing");
      }
    }

    setDrawerInnerHeight() {
      const drawerInner = this.querySelector("[data-drawer-inner]");
      const drawerHeaderWrapper = this.querySelector(
        "[data-drawer-header-wrapper]"
      );

      const drawerHeaderWrapperHeight = drawerHeaderWrapper.offsetHeight;

      drawerInner.style.height = `calc(100% - ${drawerHeaderWrapperHeight}px)`;
    }

    setHeaderCartIconAccessibility() {
      const cartLinks = document.querySelectorAll(".header__icon--cart");

      cartLinks.forEach((link) => {
        link.setAttribute("role", "button");
        link.setAttribute("aria-haspopup", "dialog");

        link.addEventListener("click", (event) => {
          event.preventDefault();
          this.open(link);
        });

        link.addEventListener("keydown", (event) => {
          if (event.code === "Space") {
            event.preventDefault();
            this.open(link);
          }
        });
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
        this.setSummaryAccessibility(cartDrawerNote);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {
        this.classList.add("animate", "active");
      });

      this.addEventListener(
        "transitionend",
        () => {
          const containerToTrapFocusOn = this.classList.contains("is-empty")
            ? this.querySelector(".drawer__inner-empty")
            : document.getElementById("CartDrawer");
          const focusElement =
            this.querySelector(".drawer__inner") ||
            this.querySelector(".drawer__close");
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );

      document.body.classList.add("overflow-hidden");
    }

    close() {
      this.classList.remove("active");
      removeTrapFocus(this.activeElement);
      document.body.classList.remove("overflow-hidden");
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute("role", "button");
      cartDrawerNote.setAttribute("aria-expanded", "false");

      if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
        cartDrawerNote.setAttribute(
          "aria-controls",
          cartDrawerNote.nextElementSibling.id
        );
      }

      cartDrawerNote.addEventListener("click", (event) => {
        event.currentTarget.setAttribute(
          "aria-expanded",
          !event.currentTarget.closest("details").hasAttribute("open")
        );
      });

      cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
    }

    renderContents(parsedState, isAddToCart = false) {
      this.querySelector(".drawer__inner").classList.contains("is-empty") &&
        this.querySelector(".drawer__inner").classList.remove("is-empty");
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (sectionElement) {
          console.log(sectionElement, "section element");
          sectionElement.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        }
      });

      if (isAddToCart) {
        this.setBannerVisibility();
        this.setShippingBarVisibility();

        setTimeout(() => {
          this.setDrawerInnerHeight();
        }, 275);
      }

      setTimeout(() => {
        this.querySelector("#CartDrawer-Overlay").addEventListener(
          "click",
          this.close.bind(this)
        );
        this.open();
        document.dispatchEvent(new CustomEvent("Cart:Drawer:Updated"));
      });
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      return [
        {
          id: "cart-drawer",
          section: "#CartDrawer",
          selector: ".drawer__inner",
        },
        {
          id: "cart-icon-bubble",
        },
      ];
    }

    getSectionDOM(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  if (!customElements.get("cart-drawer")) {
    window.CartDrawer = CartDrawer;
    customElements.define("cart-drawer", CartDrawer);
  }

  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: "CartDrawer",
          section: "cart-drawer",
          selector: ".drawer__inner",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
      ];
    }
  }

  if (!customElements.get("cart-drawer-items")) {
    window.CartDrawerItems = CartDrawerItems;
    customElements.define("cart-drawer-items", CartDrawerItems);
  }

  class CartShippingBar extends HTMLElement {
    constructor() {
      super();

      this.threshold = Number(this.getAttribute("data-threshold"));
      this.cartTotal = Number(this.getAttribute("data-cart-total")) / 100;

      this.messages = {
        emptyMessage: this.getAttribute("data-empty-message"),
        progressMessage: this.getAttribute("data-progress-message"),
        successMessage: this.getAttribute("data-success-message"),
      };

      // Create the Intl.NumberFormat instance
      const formatter = Intl.NumberFormat("en-US", {
        style: "currency",
        currency: Shopify?.currency?.active || "USD",
        minimumFractionDigits: 0, // Start without fixed decimals for whole numbers
        maximumFractionDigits: 2, // Allow up to 2 decimal places
      });

      // Override its format method
      this.currencyFormatter = {
        format(value) {
          const formattedValue = formatter.format(value);
          const [integerPart, decimalPart] = value.toFixed(2).split(".");
          if (decimalPart !== "00") {
            // Replace only the numeric part of the formatted value
            return formattedValue.replace(
              /\d+(\.\d+)?/,
              `${integerPart}.${decimalPart}`
            );
          }
          return formattedValue; // Return as-is for whole numbers
        },
      };

      this.onCartDrawerChangedHandler = this.onCartDrawerChanged.bind(this);
    }

    connectedCallback() {
      document.addEventListener(
        "Cart:Drawer:Changed",
        this.onCartDrawerChangedHandler
      );
    }

    disconnectedCallback() {
      document.removeEventListener(
        "Cart:Drawer:Changed",
        this.onCartDrawerChangedHandler
      );
    }

    formatAmount(value) {
      return this.currencyFormatter.format(value);
    }

    onCartDrawerChanged() {
      fetch(`${window?.routes?.cart_url}.js`)
        .then((response) => response.json())
        .then((cart) => {
          this.cartTotal = cart.total_price / 100;
          this.setAttribute("data-cart-total", cart.total_price);

          this.setHasSubscriptionAttribute(cart);
        });
    }

    /**
     * Updates the cart attributes to include a `has_subscription` property if necessary.
     *
     * @param {Object} cart - The cart object containing current cart details.
     * @param {Object} cart.attributes - The attributes of the cart.
     * @param {number} cart.item_count - The number of items in the cart.
     * @param {Array} cart.items - The array of items in the cart.
     * @returns {void}
     */
    setHasSubscriptionAttribute(cart) {
      const { attributes, item_count: itemCount, items } = cart;

      const hasSubscriptionItem = items.some((item) =>
        item.hasOwnProperty("selling_plan_allocation")
      );

      if (
        (hasSubscriptionItem &&
          !attributes.hasOwnProperty("has_subscription")) ||
        (!hasSubscriptionItem && attributes.hasOwnProperty("has_subscription"))
      ) {
        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          body: JSON.stringify({
            attributes: {
              has_subscription: hasSubscriptionItem || "",
            },
          }),
        })
          .then(() => {
            console.log("`has_subscription` attribute updated");
            document.dispatchEvent(new CustomEvent("Cart:Drawer:Changed"));
          })
          .catch(() => {
            console.warn("Error in updating `has_subscription` attribute");
          });
      }
    }

    get emptyMessage() {
      return String(this.messages.emptyMessage).replace(
        "||amount||",
        `<b>${this.formatAmount(this.threshold)}</b>`
      );
    }

    get progressMessage() {
      return String(this.messages.progressMessage).replace(
        "||amount||",
        `<b>${this.formatAmount(this.threshold - this.cartTotal)}</b>`
      );
    }

    attributeChangedCallback(name, _oldValue, newValue) {
      switch (name) {
        case "data-cart-total":
          this.onCartTotalUpdate(newValue);
          break;
      }
    }

    onCartTotalUpdate(val) {
      this.cartTotal = Number(val) / 100;
      if (this.cartTotal === 0) {
        this.querySelector(".shipping-bar--message p").innerHTML =
          this.emptyMessage;
        this.querySelector(".shipping-bar--message p").classList.remove(
          "success"
        );
      } else if (this.cartTotal > 0 && this.cartTotal < this.threshold) {
        this.querySelector(".shipping-bar--message p").innerHTML =
          this.progressMessage;
        this.querySelector(".shipping-bar--message p").classList.remove(
          "success"
        );
      } else {
        this.querySelector(".shipping-bar--message p").innerHTML =
          this.messages.successMessage;
        this.querySelector(".shipping-bar--message p").classList.add("success");
      }
      let progress = (this.cartTotal / this.threshold) * 100;
      this.querySelector(".shipping-bar--progress").style.width = `${
        progress > 100 ? 100 : progress
      }%`;
    }

    static get observedAttributes() {
      return ["data-cart-total"];
    }
  }

  if (!customElements.get("cart-shipping-bar")) {
    window.CartShippingBar = CartShippingBar;
    customElements.define("cart-shipping-bar", CartShippingBar);
  }

  class DrawerUpsell extends HTMLElement {
    constructor() {
      super();

      this.productId = Number(this.getAttribute("data-product-id"));

      this.currencyFormatter = Intl.NumberFormat("en-US", {
        style: "currency",
        currency: Shopify?.currency?.active || "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      this.ignoredProducts = String(this.getAttribute("data-ignored-products"))
        .split(",")
        .map((v) => Number(v));
    }

    connectedCallback() {
      const cartDrawerUpsellState = localStorage.getItem(
        "cartDrawerUpsellState"
      );
      const header = this.querySelector(".drawer-upsell--header");
      const toggleSvg = this.querySelector(".drawer-upsell--toggle svg");
      const navigation = this.querySelector(".drawer-upsell--navigation");
      const upsellButtons = this.querySelector(".drawer-upsell--buttons");
      const container = this.querySelector(".drawer-upsell--container");

      this.querySelector(".drawer-upsell--buttons--prev")?.addEventListener(
        "click",
        (event) => {
          event.preventDefault();
          this.prev();
        }
      );

      this.querySelector(".drawer-upsell--buttons--next")?.addEventListener(
        "click",
        (event) => {
          event.preventDefault();
          this.next();
        }
      );
    }

    render() {
      this.getUpsells().then((products) => {
        if (products.length) {
          let templateElement = this.querySelector("#drawer-upsell--item");
          products.forEach((product) => {
            if (this.ignoredProducts.includes(product.id)) {
              return;
            }

            let template =
              templateElement.content.firstElementChild.cloneNode(true);
            template
              .querySelector(".drawer-upsell--item__cta")
              .setAttribute("data-product", product.id);
            template
              .querySelector(".drawer-upsell--image")
              .setAttribute("src", product.featured_image);
            if (product.selling_plan_groups.length > 0) {
              template.querySelector(".drawer-upsell--selling-plan").value =
                product.selling_plan_groups[0].selling_plans[0].id;
            }
            template.querySelector(".drawer-upsell--item__title").innerHTML =
              product.title;
            template
              .querySelector(".drawer-upsell--item__title")
              .setAttribute("href", product.url);
            template
              .querySelector(".drawer-upsell--image--link")
              .setAttribute("href", product.url);
            // template.querySelector('.drawer-upsell--item__variants').innerHTML = product.variants.map(v => (v?.option1 || v?.public_title)).filter((value, index, array) => array.indexOf(value) === index).join(' / ');
            template.querySelector(".drawer-upsell--item__price").innerHTML =
              this.currencyFormatter.format(product.price / 100);
            template
              .querySelector(".drawer-upsell--item__price")
              .setAttribute("data-currency-price", product.price);
            if (product.variants.length > 1 && product.available) {
              template.querySelector(
                ".drawer-upsell--item__modal"
              ).style.display = "";
              // template.querySelector('.drawer-upsell--item__variants').style.display = '';
              template
                .querySelector(".drawer-upsell--item__modal")
                .addEventListener(
                  "click",
                  (event) => {
                    event.preventDefault();
                    this.showModal(product);
                  },
                  false
                );
            } else if (product.variants.length <= 1 && product.available) {
              // template.querySelector('.drawer-upsell--item__variants').style.display = 'none';
              template.querySelector(
                ".drawer-upsell--item__atc"
              ).style.display = "";
              template
                .querySelector(".loading-overlay")
                .classList.add("hidden");
              template
                .querySelector(".drawer-upsell--item__atc")
                .addEventListener(
                  "click",
                  (event) => {
                    event.preventDefault();
                    template.querySelector(
                      ".drawer-upsell--item__atc"
                    ).disabled = true;
                    template.querySelector(
                      ".drawer-upsell--item__atc"
                    ).style.opacity = "0";
                    template
                      .querySelector(".loading-overlay")
                      .classList.remove("hidden");
                    this.atc(product.variants.find((v) => v).id)
                      .then((res) => {
                        this.cart.renderContents(res);
                        document.dispatchEvent(
                          new CustomEvent("Cart:Drawer:Changed")
                        );
                      })
                      .catch(() => {
                        template.querySelector(
                          ".drawer-upsell--item__atc"
                        ).disabled = false;
                        template.querySelector(
                          ".drawer-upsell--item__atc"
                        ).style.opacity = "";
                        template
                          .querySelector(".loading-overlay")
                          .classList.add("hidden");
                      });
                  },
                  false
                );
            } else {
              template.querySelector(
                ".drawer-upsell--item__soldout"
              ).style.display = "";
              template
                .querySelector(".loading-overlay")
                .classList.add("hidden");
            }

            this.querySelector(
              ".drawer-upsell--container"
            ).insertAdjacentElement("beforeend", template);
          });

          this.show();
        } else {
          this.hide();
        }
      });
    }

    cleanString(str) {
      if (str === null || str === "") return false;
      else str = str.toString();

      // Regular expression to identify HTML tags in
      // the input string. Replacing the identified
      // HTML tag with a null string.
      return str.replace(/(<([^>]+)>)/gi, "");
    }

    showModal(product) {
      const cartDrawer = document.querySelector("#CartDrawer");
      let templateElement = cartDrawer.querySelector("#drawer-upsell--modal");
      let template = templateElement.content.firstElementChild.cloneNode(true);

      template.querySelector(".drawer-upsell--modal--title").innerHTML =
        product?.title;
      if (product.selling_plan_groups.length > 0) {
        template.querySelector(".drawer-upsell--selling-plan").value =
          product.selling_plan_groups[0].selling_plans[0].id;
      }
      console.log(product, "prod");
      if (product.compare_at_price) {
        template.querySelector(
          ".drawer-upsell--modal--price-original"
        ).innerHTML = this.currencyFormatter.format(product.price / 100);
        template.setAttribute("data-currency-price", product.price);
        template.querySelector(".drawer-upsell--modal--price-old").innerHTML =
          this.currencyFormatter.format(product.compare_at_price / 100);
        template
          .querySelector(".drawer-upsell--modal--price-old")
          .setAttribute("data-currency-price", product.compare_at_price);
      } else {
        template.querySelector(
          ".drawer-upsell--modal--price-original"
        ).innerHTML = this.currencyFormatter.format(product.price / 100);
        template
          .querySelector(".drawer-upsell--modal--price-original")
          .setAttribute("data-currency-price", product.price);
      }

      template.querySelector(".drawer-upsell--modal--description").innerHTML =
        this.cleanString(product?.description);
      template.querySelector(".drawer-upsell--modal--link").href = product?.url;

      const variantsContainer = template.querySelector(
        ".drawer-upsell--modal--variants"
      );

      const variantsHTML = product.variants
        .map((variant, index) => {
          const isAvailable = variant.available ? "" : "disabled";
          const isSelected =
            variant.available &&
            product.variants.findIndex((v) => v.available) === index
              ? "selected"
              : "";

          return `
        <button 
          type="button" 
          ${isAvailable} 
          class="drawer-upsell--modal--variant ${isSelected}" 
          data-vid="${variant.id}">
          ${variant.public_title}
        </button>`;
        })
        .join("");

      variantsContainer.innerHTML = variantsHTML;

      if (product.featured_image) {
        template.querySelector(
          ".drawer-upsell--modal--slideshow-main"
        ).innerHTML = `
          <div class="drawer-upsell--modal--slideshow-main--item">
            <img src="${product.featured_image}" />
          </div>
        `;
      }
      document.body.insertAdjacentElement("beforeend", template);
      document.dispatchEvent(new CustomEvent("Upsell:Modal:Show"));
    }

    show() {
      this.style.display = "";
    }

    hide() {
      this.style.display = "none";
    }

    getUpsells() {
      return fetch(
        `${window.Shopify.routes.root}recommendations/products.json?product_id=${this.productId}&limit=4&intent=related`
      )
        .then((response) => response.json())
        .then(({ products }) => {
          return products;
        });
    }

    onUpdateProductId(value) {
      this.productId = Number(value);
      if (this.productId) {
        this.render();
      }
    }

    atc(id) {
      return fetch("/cart/add.js", {
        body: JSON.stringify({
          items: [
            {
              id,
              quantity: this.quantity,
            },
          ],
          sections: "cart-drawer,cart-icon-bubble",
        }),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With":
            "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
        },
        method: "POST",
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {
          document.dispatchEvent(new CustomEvent("Cart:Drawer:Changed"));
          return json;
        })
        .catch(function (err) {
          return err;
        });
    }

    attributeChangedCallback(name, _oldValue, newValue) {
      switch (name) {
        case "data-product-id":
          this.onUpdateProductId(newValue);
          break;
      }
    }

    static get observedAttributes() {
      return ["data-product-id"];
    }
  }

  if (!customElements.get("drawer-upsell")) {
    window.DrawerUpsell = DrawerUpsell;
    customElements.define("drawer-upsell", DrawerUpsell);
  }

  class LiquidUpsell extends HTMLElement {
    constructor() {
      super();

      const pairsWithScript = this.querySelector(
        "script[data-pairs-with-product]"
      );

      if (pairsWithScript) {
        try {
          this.pairsWithData = JSON.parse(pairsWithScript.textContent.trim());
        } catch (error) {
          console.error("Error parsing JSON data:", error);
          this.pairsWithData = {};
        }
      }

      this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      this.modalToggle = this.querySelector("[data-pairs-with-modal-toggle]");

      this.addToCartButton = this.querySelector("[data-pairs-with-atc]");

      if (this.getAttribute("data-parent-item")) {
        this.parentBundleKey = this.getAttribute("data-parent-item");
      }

      if (this.getAttribute("data-selling-plan")) {
        this.parentSellingPlan = Number(this.getAttribute("data-selling-plan"));
      }

      this.currencyFormatter = Intl.NumberFormat("en-US", {
        style: "currency",
        currency: Shopify?.currency?.active || "USD",
        maximumSignificantDigits: 4,
      });
    }

    connectedCallback() {
      if (this.modalToggle) {
        this.modalToggle.addEventListener("click", () =>
          this.showModal(this.parentBundleKey, this.parentSellingPlan)
        );
      }

      if (this.addToCartButton) {
        this.addToCartButton.addEventListener("click", () =>
          this.onAddToCartClick()
        );
      }
    }

    cleanString(str) {
      if (str === null || str === "") return false;
      else str = str.toString();

      return str.replace(/(<([^>]+)>)/gi, "");
    }

    atc(id, sellingPlan) {
      return fetch("/cart/add.js", {
        body: JSON.stringify({
          items: [
            {
              id,
              quantity: 1,
              selling_plan: sellingPlan || null,
            },
          ],
          sections: "cart-drawer,cart-icon-bubble",
        }),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "xmlhttprequest",
        },
        method: "POST",
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          return json;
        })
        .then((response) => {
          const parentItemKey = this.getAttribute("data-parent-item");
          if (parentItemKey) {
            // Remove the parent item
            return fetch("/cart/update.js", {
              body: JSON.stringify({
                updates: {
                  [this.parentBundleKey]: 0,
                },
                sections: "cart-drawer,cart-icon-bubble",
              }),
              credentials: "same-origin",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "xmlhttprequest",
              },
              method: "POST",
            })
              .then(function (updateResponse) {
                return updateResponse.json();
              })
              .then(function (updateJson) {
                return updateJson;
              });
          }

          return response;
        })
        .catch((err) => {
          console.error("Error in ATC function", err);
          return err;
        });
    }

    onAddToCartClick() {
      let variantId = this.addToCartButton.getAttribute("data-pairs-with-atc");
      let sellingPlan = this.addToCartButton.getAttribute("data-selling-plan");

      if (!variantId) return;

      variantId = Number(variantId);

      this.querySelector(".loading-overlay").classList.remove("hidden");
      this.addToCartButton.style.opacity = 0;
      this.atc(variantId, sellingPlan)
        .then((res) => {
          this.cart.renderContents(res);
        })
        .catch(() => {
          console.log("Error in adding pair with item to the cart");
        })
        .finally(() => {
          this.querySelector(".loading-overlay").classList.add("hidden");
          this.addToCartButton.style.opacity = 1;
          document.dispatchEvent(new CustomEvent("Cart:Drawer:Changed"));
        });
    }

    showModal(parentBundleKey, parentSellingPlan) {
      const product = this.pairsWithData;

      const cartDrawer = document.querySelector("#CartDrawer");
      let templateElement = cartDrawer.querySelector("#drawer-upsell--modal");
      let template = templateElement.content.firstElementChild.cloneNode(true);

      template.querySelector(".drawer-upsell--modal--title").innerHTML =
        product?.title;

      let sellingPlan = this.modalToggle.getAttribute("data-selling-plan");

      if (sellingPlan) {
        template.querySelector(".drawer-upsell--selling-plan").value =
          sellingPlan;
      }

      if (parentBundleKey) {
        template.querySelector(".drawer-upsell--parent-item").value =
          parentBundleKey;
      }

      if (parentSellingPlan) {
        const { price, selling_plan_groups } = product;

        let adjustedPrice;

        const matchingPlan = selling_plan_groups
          .flatMap((group) => group.selling_plans)
          .find((plan) => Number(plan.id) === parentSellingPlan);

        if (matchingPlan) {
          const { value, value_type } = matchingPlan.price_adjustments[0];

          if (value_type === "percentage") {
            adjustedPrice = price - (price * value) / 100;
          } else if (value_type === "fixed_amount") {
            adjustedPrice = price - value;
          }
        }

        template.querySelector(
          ".drawer-upsell--modal--price-original"
        ).innerHTML = this.currencyFormatter.format(adjustedPrice / 100);
      } else if (product.compare_at_price) {
        template.querySelector(
          ".drawer-upsell--modal--price-original"
        ).innerHTML = this.currencyFormatter.format(product.price / 100);
        template.querySelector(".drawer-upsell--modal--price-old").innerHTML =
          this.currencyFormatter.format(product.compare_at_price / 100);
      } else {
        template.querySelector(
          ".drawer-upsell--modal--price-original"
        ).innerHTML = this.currencyFormatter.format(product.price / 100);
      }

      template.querySelector(".drawer-upsell--modal--description").innerHTML =
        this.cleanString(product?.description);
      template.querySelector(".drawer-upsell--modal--link").href =
        product?.handle;

      const variantsContainer = template.querySelector(
        ".drawer-upsell--modal--variants"
      );

      const variantsHTML = product.variants
        .map((variant, index) => {
          const isAvailable = variant.available ? "" : "disabled";
          const isSelected =
            variant.available &&
            product.variants.findIndex((v) => v.available) === index
              ? "selected"
              : "";

          return `
          <button 
            type="button" 
            ${isAvailable} 
            class="drawer-upsell--modal--variant ${isSelected}" 
            data-vid="${variant.id}">
            ${variant.public_title}
          </button>`;
        })
        .join("");

      variantsContainer.innerHTML = variantsHTML;

      if (product.featured_image) {
        template.querySelector(
          ".drawer-upsell--modal--slideshow-main"
        ).innerHTML = `
            <div class="drawer-upsell--modal--slideshow-main--item">
              <img src="${product.featured_image}" />
            </div>
          `;
      }

      document.body.insertAdjacentElement("beforeend", template);
    }
  }

  customElements.define("liquid-upsell", LiquidUpsell);

  class DrawerUpsellModal extends HTMLElement {
    constructor() {
      super();

      this.quantity = 1;
      this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
    }

    params() {
      let selected = [
        ...this.querySelectorAll(".drawer-upsell--modal--variant"),
      ].find((el) => el.classList.contains("selected"));
      let selling_plan = "";
      if (this.querySelector(".drawer-upsell--selling-plan")) {
        selling_plan = this.querySelector(".drawer-upsell--selling-plan").value;
      }
      if (selling_plan !== "") {
        return {
          items: [
            {
              id: selected.getAttribute("data-vid") || 0,
              quantity: this.quantity,
              selling_plan: selling_plan,
            },
          ],
          sections: "cart-drawer,cart-icon-bubble",
        };
      }
      return {
        items: [
          {
            id: selected.getAttribute("data-vid") || 0,
            quantity: this.quantity,
          },
        ],
        sections: "cart-drawer,cart-icon-bubble",
      };
    }

    atc(params, parentBundleKey) {
      let data = {
        items: [],
        sections: "cart-drawer,cart-icon-bubble",
      };
      data.items = params.items;
      console.log(data.items);
      return fetch("/cart/add.js", {
        body: JSON.stringify(data),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "xmlhttprequest",
        },
        method: "POST",
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          return json;
        })
        .then((response) => {
          if (parentBundleKey) {
            // Remove the parent item
            return fetch("/cart/update.js", {
              body: JSON.stringify({
                updates: {
                  [parentBundleKey]: 0,
                },
                sections: "cart-drawer,cart-icon-bubble",
              }),
              credentials: "same-origin",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "xmlhttprequest",
              },
              method: "POST",
            })
              .then(function (updateResponse) {
                return updateResponse.json();
              })
              .then(function (updateJson) {
                return updateJson;
              });
          }

          return response;
        })
        .catch(function (err) {
          return err;
        });
    }

    renderQuantity() {
      this.querySelector(".drawer-upsell--modal--quantity--value").innerHTML =
        this.quantity;
    }

    connectedCallback() {
      this.addEventListener(
        "click",
        (event) => {
          if (
            !this.querySelector(".drawer-upsell--modal--container").contains(
              event.target
            )
          ) {
            event.preventDefault();
            this.remove();
          }
        },
        false
      );

      [...this.querySelectorAll(".drawer-upsell--modal--variant")].forEach(
        (el, elidx, list) => {
          el.addEventListener(
            "click",
            (event) => {
              event.preventDefault();
              list.forEach((i) => i.classList.remove("selected"));
              el.classList.add("selected");
            },
            false
          );
        }
      );

      this.querySelector(".drawer-upsell--modal--add").addEventListener(
        "click",
        (event) => {
          event.preventDefault();

          let parentBundleKey;

          if (this.querySelector(".drawer-upsell--parent-item").value) {
            parentBundleKey = this.querySelector(
              ".drawer-upsell--parent-item"
            ).value;
          }

          let params = this.params(parentBundleKey);
          this.querySelector(".drawer-upsell--modal--add").disabled = true;
          this.querySelector(".drawer-upsell--modal--add").style.opacity =
            "0.5";
          this.atc(params, parentBundleKey)
            .then((res) => {
              this.remove();
              this.cart.renderContents(res);
              document.dispatchEvent(new CustomEvent("Cart:Drawer:Changed"));
            })
            .catch(() => {
              this.querySelector(".drawer-upsell--modal--add").disabled = false;
              this.querySelector(".drawer-upsell--modal--add").style.opacity =
                "";
            });
        },
        false
      );

      this.querySelector(
        ".drawer-upsell--modal--quantity--minus"
      ).addEventListener("click", (event) => {
        event.preventDefault();
        if (this.quantity <= 1) {
          this.quantity = 1;
        } else {
          this.quantity--;
        }

        this.renderQuantity();
      });

      this.querySelector(
        ".drawer-upsell--modal--quantity--plus"
      ).addEventListener("click", (event) => {
        event.preventDefault();
        this.quantity++;
        this.renderQuantity();
      });

      this.querySelector(".drawer-upsell--modal--close").addEventListener(
        "click",
        (event) => {
          event.preventDefault();
          this.remove();
        },
        false
      );

      this.renderQuantity();
    }
  }

  if (!customElements.get("drawer-upsell-modal")) {
    window.DrawerUpsellModal = DrawerUpsellModal;
    customElements.define("drawer-upsell-modal", DrawerUpsellModal);
  }
})();
